import React from 'react';
import PropTypes from 'prop-types';
import { ComponentLoader } from './ComponentLoader/ComponentLoader';

/**
 * TooltipWrapper Component Loader (dibs-elements/dist/Tooltip)
 */
const importFunc = () => {
    return import(
        /* webpackChunkName: "Tooltip" */
        'dibs-elements/exports/Tooltip'
    ).then(moduleExport => moduleExport.Tooltip);
};

export function TooltipLoader(props) {
    return (
        <ComponentLoader
            {...props}
            load={props.load}
            importFunc={importFunc}
            useLoadingComponent={false}
        />
    );
}

TooltipLoader.propTypes = {
    load: PropTypes.bool.isRequired,
};
